import type { core } from 'zod'

declare global {
  // zod keeps its config on this global, so every copy of zod loaded on a page shares it.
  // eslint-disable-next-line vars-on-top -- a global declaration has no function scope to hoist to
  var __zod_globalConfig: Partial<core.$ZodConfig> | undefined
}

/**
 * Turns off zod's eval before any schema is built in the browser.
 *
 * zod probes for eval with `new Function('')` when it builds its first object schema, then
 * compiles each object parser with `new Function`. The CSP has no 'unsafe-eval', so every page
 * that loads a schema reported a violation. zod catches the refusal and parses without the
 * compiled parsers, which is what `jitless` makes it do from the start.
 *
 * The setting goes on the global zod reads its config from, rather than through `z.config()`,
 * so this plugin does not import zod and put it on pages that parse nothing, such as the
 * landing page.
 */
export default defineNuxtPlugin({
  name: 'zod-jitless',
  // Ahead of Nuxt's router (`enforce: 'pre'`, order -20). Its first navigation loads the page,
  // and the page builds its schemas as it loads.
  order: -25,
  setup() {
    globalThis.__zod_globalConfig ??= {}
    globalThis.__zod_globalConfig.jitless = true
  },
})
